// React
import { createContext } from 'react'
// MainStem - API
import { MainStemAPIPlatformControllersPurchasingAuthCurrentUserAPIResponse } from 'api-new'

export const AppContext = createContext({} as AppContextDetails)

export interface AppContextDetails {
  addMessages: (messages: Array<IMessage>) => void
  integrations: IAppContextIntegrations
  loggedInUser: MainStemAPIPlatformControllersPurchasingAuthCurrentUserAPIResponse
  messages: Array<IMessage>
  particlesInitiated: boolean
  permissions: any
  setIntegrations: React.Dispatch<React.SetStateAction<IAppContextIntegrations>>
  setLoggedInUser: React.Dispatch<
    React.SetStateAction<MainStemAPIPlatformControllersPurchasingAuthCurrentUserAPIResponse | undefined>
  >
  setPermissions: React.Dispatch<React.SetStateAction<any | undefined>>
  setUserToken: React.Dispatch<React.SetStateAction<string | undefined>>
  userToken: string
}

export type IMessage = {
  message: React.ReactNode
  type: 'user' | 'bot'
}

export type IAppContextIntegrations = Record<string, never>
